module.exports = __webpack_public_path__ + "img/manager_bg_.dfa98058.png";